import React, {useCallback, useState, useRef} from "react"
import './video-txt.scss';
import {setImageNoAutooplay} from "../../utils/set-image-no-autoplay";
// Defining the <Greeting> component
export const VideoTxt = (props) => {
  const [imageBehind, setVisibleImage] = useState(false);
  const fallbackImage = useRef(null);
  const videoVisible = useRef(null);
  let imgSrc = props.poster;

  const videoLoad = useCallback(
    (e) => {
      setImageNoAutooplay(videoVisible.current, setVisibleImage)
    },
    [],
  )
  
  return (
    <div className ="videoTxt">
      <video className="videoTxt__video" preload='auto' poster={props.poster}  ref={videoVisible} loop autoPlay muted playsInline onLoadedData={videoLoad}>
        <source src={props.video} type="video/mp4" />
      </video>
      <img className={`${imageBehind ? 'videoTxt__img--visible' : ''} videoTxt__img`} src={`${imageBehind ? imgSrc : ''}`}  ref={fallbackImage} alt="sea background" />
      <div className ="videoTxt__animCont">
        <div className="videoTxt__anim">
          <h2 className="videoTxt__animTxt"> {props.text}</h2>
          <h2 className="videoTxt__animTxt"> {props.text} </h2>
          <h2 className="videoTxt__animTxt"> {props.text} </h2>
          <h2 className="videoTxt__animTxt"> {props.text} </h2>
        </div>
      </div>
    </div>
        
    )
  }